import { render, staticRenderFns } from "./ModalPhoneNumber.vue?vue&type=template&id=6df3cb4e&scoped=true&"
import script from "./ModalPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./ModalPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./ModalPhoneNumber.vue?vue&type=style&index=0&id=6df3cb4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df3cb4e",
  null
  
)

export default component.exports